import { getCountries, getCountryCallingCode } from 'libphonenumber-js';

const CALLING_CODES = new Set<string>(getCountries().map((country) => getCountryCallingCode(country)));

/** Whether the phone is only a country's dial code (`+52`): what an untouched `PhoneInput` holds. */
export function isDialCodeOnly(phone: string): boolean {
    const digits = /^\+(\d+)$/.exec(phone.trim())?.[1];
    return digits !== undefined && CALLING_CODES.has(digits);
}
